import { ResponseError } from "@nimble/react-requests/api-clients/fetch-config";
import { ResponseErrorAlert } from "@nimble/react-requests/components/shared/response-error-alert";
import { ResultAsync } from "neverthrow";
import { notFound } from "next/navigation";

const UNAUTHENTICATED_STATUS = 401;

export function isUnauthenticatedError(error: Error): boolean {
  return (
    error instanceof ResponseError && error.status === UNAUTHENTICATED_STATUS
  );
}

export function neverthrowize<T extends readonly unknown[]>(
  promises: [...{ [K in keyof T]: Promise<T[K]> }],
) {
  return ResultAsync.fromPromise(
    Promise.all(promises) as Promise<T>,
    (e) => e as Error,
  );
}

export function handleResponseErrorAsPage(error: Error): React.ReactNode {
  if (error instanceof ResponseError && error.status === 404) {
    notFound();
  }
  return <ResponseErrorAlert error={error} />;
}

export function handleResponseErrorAsMetadata(error: Error): never {
  if (error instanceof ResponseError && error.status === 404) {
    notFound();
  }
  throw error;
}

export default async function callServerApi<T extends readonly unknown[]>(
  promises: [...{ [K in keyof T]: Promise<T[K]> }],
  successFn: (value: T) => React.ReactNode,
): Promise<React.ReactNode> {
  const result = await neverthrowize<T>(promises);

  return result.match(successFn, (error) => (
    <ResponseErrorAlert error={error} />
  ));
}
